import configureStore from 'Application/store/configureStore';

const { store, persistor, history } = configureStore();

export { store, persistor, history };
